import React, { useContext } from "react";
import { Link as RouterLink } from "react-router-dom";

import AdminPanelSettingsOutlinedIcon from "@mui/icons-material/AdminPanelSettingsOutlined";
import AssessmentOutlinedIcon from "@mui/icons-material/AssessmentOutlined";
import ContactPhoneOutlinedIcon from "@mui/icons-material/ContactPhoneOutlined";
import DashboardOutlinedIcon from "@mui/icons-material/DashboardOutlined";
import PeopleOutlineOutlinedIcon from "@mui/icons-material/PeopleOutlineOutlined";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import Divider from "@mui/material/Divider";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import ListSubheader from "@mui/material/ListSubheader";

import { Can } from "../components/Can";
import { AuthContext } from "../context/Auth/AuthContext";
import { i18n } from "../translate/i18n";

function ListItemLink(props) {
  const { icon, primary, to, className } = props;

  const renderLink = React.useMemo(
    () =>
      React.forwardRef((itemProps, ref) => (
        <RouterLink to={to} ref={ref} {...itemProps} />
      )),
    [to],
  );

  return (
    <li>
      <ListItemButton component={renderLink} className={className}>
        {icon ? <ListItemIcon>{icon}</ListItemIcon> : null}
        <ListItemText primary={primary} />
      </ListItemButton>
    </li>
  );
}

const MainListItems = (props) => {
  const { drawerClose } = props;
  const { user } = useContext(AuthContext);

  return (
    <div onClick={drawerClose}>
      {/* Platform admin section — superadmin only */}
      <Can role={user.profile} perform="superadmin-panel:view" yes={() => (
        <>
          <ListSubheader sx={{ fontSize: "0.68rem", letterSpacing: "0.6px", lineHeight: "2.2rem", bgcolor: "transparent" }}>
            Platform Admin
          </ListSubheader>
          <ListItemLink
            to="/superadmin"
            primary="Customers"
            icon={<PeopleOutlineOutlinedIcon />}
          />
          <Divider sx={{ my: 1 }} />
        </>
      )} />

      <ListItemLink
        to="/dashboard"
        primary="Dashboard"
        icon={<DashboardOutlinedIcon />}
      />
      <ListItemLink
        to="/tickets"
        primary={i18n.t("mainDrawer.listItems.tickets")}
        icon={<WhatsAppIcon />}
      />
      <ListItemLink
        to="/contacts"
        primary={i18n.t("mainDrawer.listItems.contacts")}
        icon={<ContactPhoneOutlinedIcon />}
      />
      <ListItemLink
        to="/reports"
        primary="Analytics"
        icon={<AssessmentOutlinedIcon />}
      />
      <ListItemLink
        to="/settings"
        primary={i18n.t("mainDrawer.listItems.settings")}
        icon={<SettingsOutlinedIcon />}
      />
    </div>
  );
};

export default MainListItems;
